import type { GuestDetailsLayout } from '../constants/guestLayout';

export function resolveAccordionPadding(layout: GuestDetailsLayout): number {
  if (layout.isPhone) {
    return 16;
  }
  if (layout.isCompact) {
    return 20;
  }
  return 24;
}

export function resolveAccordionHeaderPadX(layout: GuestDetailsLayout): number {
  if (layout.isPhone) {
    return 12;
  }
  return 16;
}

export function resolveAccordionHeaderPadBottom(
  layout: GuestDetailsLayout,
): number {
  if (layout.isPhone) {
    return 12;
  }
  if (layout.isCompact) {
    return 16;
  }
  return 24;
}

export function resolveAccordionHeaderGap(layout: GuestDetailsLayout): number {
  return resolveAccordionHeaderPadX(layout);
}

/** Shared WebAccordion frame props for guest details sections. */
export function getGuestWebAccordionFrame(
  layout: GuestDetailsLayout,
): Readonly<{
  padding: number;
  headerPaddingHorizontal: number;
  headerPaddingBottom: number;
  headerGap: number;
}> {
  return {
    padding: resolveAccordionPadding(layout),
    headerPaddingHorizontal: resolveAccordionHeaderPadX(layout),
    headerPaddingBottom: resolveAccordionHeaderPadBottom(layout),
    headerGap: resolveAccordionHeaderGap(layout),
  };
}
